import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import ContactSidebar from "./components/ContactSidebar/ContactSidebar";
import Home from "./pages/home/home";
import Déménagement from "./pages/demenagement/demenagement";
import Livraison from "./pages/livrasion/livrasion";
import RamassageDebris from "./pages/Ramassage/Ramassage";
import Login from "./pages/login/LoginPage";
import AdminPage from "./pages/PageAdmin/PageAdmin";
import UserPage from "./pages/PageUser/PageUser";
import SuperAdminPage from "./pages/PageSuperAdmin/PageSuperAdmin";
import CollaborationEntreprise from "./pages/collaboration-entreprise/collaboration-entreprise";
import ScrollToTop from "./ScrollToTop";

import "./app.css";

function AppContent() {
  const location = useLocation();

  // Pages où le footer ne doit pas être affiché
  const pagesWithoutFooter = ["/login", "/admin", "/user"];

  // Vérifier si on est sur une page admin (incluant les sous-routes)
  const isAdminPage = location.pathname.startsWith("/admin");
  const isUserPage = location.pathname.startsWith("/user");

  const shouldShowFooter =
    !pagesWithoutFooter.includes(location.pathname) &&
    !isAdminPage &&
    !isUserPage;

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Déménagement" element={<Déménagement />} />
        <Route path="/D%C3%A9menagement" element={<Déménagement />} />
        <Route path="/Livraison" element={<Livraison />} />
        <Route path="/RamassageDebris" element={<RamassageDebris />} />
        <Route
          path="/collaboration-entreprise"
          element={<CollaborationEntreprise />}
        />
        {/* Routes imbriquées pour l'admin */}
        <Route path="/admin/*" element={<AdminPage />} />
        <Route path="/user/*" element={<UserPage />} />
        <Route path="/login" element={<Login />} />
      </Routes>

      {shouldShowFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
            <ScrollToTop />

      <AppContent />
    </Router>
  );
}

export default App;
